// src/components/product.js

export const PRODUCTS = [
  /* ======================
     TVASHTA HONEY
  ====================== */

  {
    id: 1,
    title: "Tvashta Shilajit – 500gm",
    image: "/images/shop/shilajit.png",
    price: 600,
    oldPrice: 999,
    category: "Tvashta Honey",
    slug: "tvashta-shilajit-500gm",
    specs: {
      flavour: "Shilajit",
      treatment: "Filtered Honey",
      shelfLife: "18 Months",
      itemWeight: "500 gm",
      speciality: "Energy Booster",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 2,
    title: "Tvashta Ginger – 500gm",
    image: "/images/shop/ginger.png",
    price: 350,
    oldPrice: 699,
    category: "Tvashta Honey",
    slug: "tvashta-ginger-500gm",
    specs: {
      flavour: "Ginger",
      treatment: "Filtered Honey",
      shelfLife: "18 Months",
      itemWeight: "500 gm",
      speciality: "Digestion Support",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 3,
    title: "Tvashta Dark Forest – 500gm",
    image: "/images/shop/darkforest.png",
    price: 450,
    oldPrice: 700,
    category: "Tvashta Honey",
    slug: "tvashta-dark-forest-500gm",
    specs: {
      flavour: "Dark Forest",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Rich Minerals",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 4,
    title: "Tvashta Litchi – 500gm",
    image: "/images/shop/lichi.png",
    price: 350,
    oldPrice: 405,
    category: "Tvashta Honey",
    slug: "tvashta-litchi-500gm",
    specs: {
      flavour: "Litchi",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Natural Sweetness",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 5,
    title: "Tvashta Neem – 500gm",
    image: "/images/shop/neem.png",
    price: 350,
    oldPrice: 499,
    category: "Tvashta Honey",
    slug: "tvashta-neem-500gm",
    specs: {
      flavour: "Neem",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Natural Energy",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 7,
    title: "Tvashta Tulsi – 500gm",
    image: "/images/shop/tulsi.png",
    price: 350,
    oldPrice: 450,
    category: "Tvashta Honey",
    slug: "tvashta-tulsi-500gm",
    specs: {
      flavour: "Tulsi",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Immunity Booster",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 8,
    title: "Tvashta Berry – 500gm",
    image: "/images/shop/berry.png",
    price: 350,
    oldPrice: 499,
    category: "Tvashta Honey",
    slug: "tvashta-berry-500gm",
    specs: {
      flavour: "Berry",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Antioxidant Rich",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 9,
    title: "Tvashta Acacia – 500gm",
    image: "/images/shop/acacia.png",
    price: 350,
    oldPrice: 450,
    category: "Tvashta Honey",
    slug: "tvashta-acacia-500gm",
    specs: {
      flavour: "Acacia",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Low Glycemic",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 10,
    title: "Tvashta Ajwain – 500gm",
    image: "/images/shop/ajwain.png",
    price: 300,
    oldPrice: 360,
    category: "Tvashta Honey",
    slug: "tvashta-ajwain-500gm",
    specs: {
      flavour: "Ajwain",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Digestive Health",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 11,
    title: "Tvashta Jamun – 500gm",
    image: "/images/shop/jamun.png",
    price: 350,
    oldPrice: 405,
    category: "Tvashta Honey",
    slug: "tvashta-jamun-500gm",
    specs: {
      flavour: "Jamun",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Sugar Balance",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },
  {
    id: 12,
    title: "Tvashta Sunflower – 500gm",
    image: "/images/shop/sunflower.png",
    price: 350,
    oldPrice: 450,
    category: "Tvashta Honey",
    slug: "tvashta-sunflower-500gm",
    specs: {
      flavour: "Sunflower",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Heart Health",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },

  {
    id: 13,
    title: "Tvashta Yellow Forest – 500gm",
    image: "/images/shop/yellowforest.png",
    price: 450,
    oldPrice: 700,
    category: "Tvashta Honey",
    slug: "tvashta-yellow-forest-500gm",
    specs: {
      flavour: "Yellow Forest",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Natural Energy",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },

  {
    id: 14,
    title: "Tvashta Eucalyptus – 500gm",
    image: "/images/shop/eucalyptus.png",
    price: 350,
    oldPrice: 450,
    category: "Tvashta Honey",
    slug: "tvashta-eucalyptus-500gm",
    specs: {
      flavour: "Eucalyptus",
      treatment: "Raw Honey",
      shelfLife: "24 Months",
      itemWeight: "500 gm",
      speciality: "Respiratory Support",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },

  {
    id: 15,
    title: "Tvashta Moringa – 500gm",
    price: 540,
    oldPrice: 700,
    image: "/images/shop/moringa.png",
    category: "Tvashta Honey",
    slug: "tvashta-moringa-500gm",
    specs: {
      flavour: "Moringa",
      treatment: "Filtered Honey",
      shelfLife: "18 Months",
      itemWeight: "500 gm",
      speciality: "Certified Organic",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },

  {
    id: 16,
    title: "Tvashta Cinnamon – 500gm",
    image: "/images/shop/cinnamon.png",
    price: 540,
    oldPrice: 700,
    category: "Tvashta Honey",
    slug: "tvashta-cinnamon-500gm",
    specs: {
      flavour: "Cinnamon",
      treatment: "Filtered Honey",
      shelfLife: "18 Months",
      itemWeight: "500 gm",
      speciality: "Immunity Support",
      packageWeight: "500 gm",
      packageType: "Jar",
      numberOfItems: "1",
      netQuantity: "1.00 count",
    },
  },

  /* ======================
     SHREE GAYATRI SHAKTI
  ====================== */

  {
    id: 16,
    title: "Shri Gayatri Shakti – 25gm",
    image: "/images/shop/sgs-25.png",
    price: 30,
    category: "Shree Gayatri Shakti",
    slug: "shri-gayatri-shakti-25gm",
    bulkQty: 10,
    specs: {
      flavour: "Herbal",
      itemWeight: "25 gm",
      packageType: "Bottle",
      numberOfItems: "10",
      netQuantity: "25 gm",
    },
  },

  {
    id: 17,
    title: "Shri Gayatri Shakti – 50gm",
    image: "/images/shop/sgs-50.png",
    price: 45,
    category: "Shree Gayatri Shakti",
    slug: "shri-gayatri-shakti-50gm",
    bulkQty: 10,
    specs: {
      flavour: "Herbal",
      itemWeight: "50 gm",
      packageType: "Bottle",
      numberOfItems: "1",
      netQuantity: "50 gm",
    },
  },

  {
    id: 18,
    title: "Shri Gayatri Shakti – 100gm",
    image: "/images/shop/sgs-100.png",
    price: 70,
    category: "Shree Gayatri Shakti",
    slug: "shri-gayatri-shakti-100gm",
    bulkQty: 10,
    specs: {
      flavour: "Herbal",
      itemWeight: "100 gm",
      packageType: "Bottle",
      numberOfItems: "1",
      netQuantity: "100 gm",
    },
  },

  {
    id: 19,
    title: "Shri Gayatri Shakti – 200gm",
    image: "/images/shop/sgs-200.png",
    price: 110,
    category: "Shree Gayatri Shakti",
    slug: "shri-gayatri-shakti-200gm",
    bulkQty: 10,
    specs: {
      flavour: "Herbal",
      itemWeight: "200 gm",
      packageType: "Bottle",
      numberOfItems: "1",
      netQuantity: "200 gm",
    },
  },

  {
    id: 20,
    title: "Shri Gayatri Shakti – 500gm",
    image: "/images/shop/sgs-500.png",
    price: 235,
    category: "Shree Gayatri Shakti",
    slug: "shri-gayatri-shakti-500gm",
    specs: {
      flavour: "Herbal",
      itemWeight: "500 gm",
      packageType: "Bottle",
      numberOfItems: "1",
      netQuantity: "500 gm",
    },
  },

  {
    id: 21,
    title: "Shri Gayatri Shakti – 1kg",
    image: "/images/shop/sgs-1kg.png",
    price: 450,
    category: "Shree Gayatri Shakti",
    slug: "shri-gayatri-shakti-1kg",
    specs: {
      flavour: "Herbal",
      itemWeight: "1 kg",
      packageType: "Bottle",
      numberOfItems: "1",
      netQuantity: "1 kg",
    },
  },

  /* ======================
     B2B
  ====================== */

  {
    id: 22,
    title: "B2B – 30kg Can",
    image: "/images/shop/b2b-30kg.png",
    price: 0,
    category: "B2B",
    buttonText: "Read more",
    slug: "b2b-30kg-can",
    specs: {
      itemWeight: "30 kg",
      packageType: "Can",
      speciality: "Bulk Supply",
      numberOfItems: "1",
    },
  },
];

export const FIXED_SPECS = {
  Brand: "TVASHTA HONEY",
  "Keep Cool And Dry Place": "Dry Place",
  "Food Grade Medicine Grade": "Food Grade Pat Jar",
  "Blood Refiner Nutritive Tonic": "For Daily Energy",
  Manufacturer: "SHRI HARI MADHUR BHANDAR",
  "Country of Origin": "Made in India",
};

export const CATEGORIES = [
  "All",
  "Tvashta Honey",
  "Shree Gayatri Shakti",
  "B2B",
];
